import React from 'react'
import { Box, BoxProps, Table } from '@workwhile/ui'
import { ColumnDef, OnChangeFn, PaginationState } from '@tanstack/react-table'
import { TableEmptyState } from './TableEmptyState'

type PaginatedTableProps<T> = {
  columns: ColumnDef<T>[]
  items: T[]
  rowCount: number
  pagination: PaginationState
  setPagination: OnChangeFn<PaginationState>
  isFetching: boolean
  emptyMessage: React.ReactNode
  emptyStateHeight?: number
  emptyStateMaxWidth?: BoxProps['maxWidth']
  stickyHeader?: boolean
  textVerticalAlign?: 'top' | 'middle' | 'bottom'
}

export function PaginatedTable<T extends object>({
  columns,
  items,
  rowCount,
  pagination,
  setPagination,
  isFetching,
  emptyMessage,
  emptyStateHeight = 258,
  emptyStateMaxWidth,
  stickyHeader,
  textVerticalAlign = 'top',
}: PaginatedTableProps<T>) {
  const doesHaveData = items.length > 0

  return (
    <Box>
      {doesHaveData ? (
        <Table
          columns={columns}
          data={items}
          stickyHeader={stickyHeader}
          textVerticalAlign={textVerticalAlign}
          serverPagination={{
            rowCount,
            state: pagination,
            setState: setPagination,
          }}
        />
      ) : (
        <TableEmptyState
          isFetching={isFetching}
          emptyMessage={emptyMessage}
          emptyStateHeight={emptyStateHeight}
          emptyStateMaxWidth={emptyStateMaxWidth}
        />
      )}
    </Box>
  )
}
